<script>
  import router from "@/router";

  import NavBar from "@/components/nav-bar";
  import SideBar from "@/components/side-bar";
  import TopNav from "@/components/top-nav";
  import Footer from "@/components/footer";
  import VirtualTourView from "@/components/widgets/virtual-tour-view";
  import SupportEmail from "@/components/widgets/supportEmail";

  import { mapState } from 'vuex'

  /**
   * Vertical layout
   */
  export default {
    components: { NavBar, SideBar, TopNav, Footer, VirtualTourView, SupportEmail },
    data() {
      return {
        isMenuCondensed: false,
      };
    },
    created: () => {
      document.body.removeAttribute("data-layout", "horizontal");
      document.body.removeAttribute("data-topbar", "dark");
      document.body.removeAttribute("data-layout-size", "boxed");
      document.body.classList.remove("auth-body-bg");
    },
    computed: {
      ...mapState("property",["properties"]),
      virtualTourLink() {
        if(this.$route.params) {
          const propId = this.$route.params.id ?? this.$route.params.propId;
          const property = this.properties.find(prop => prop.id == propId);
          if (property)
            return property.activation_info.virtual_tour_link;
          else
            return null;
        }
        return null;
      }
      
    },
    methods: {
      toggleMenu() {
        document.body.classList.toggle("sidebar-enable");

        if (window.screen.width >= 992) {
          // eslint-disable-next-line no-unused-vars
          router.afterEach((routeTo, routeFrom) => {
            document.body.classList.remove("sidebar-enable");
            document.body.classList.remove("vertical-collpsed");
          });
          document.body.classList.toggle("vertical-collpsed");
        } else {
          // eslint-disable-next-line no-unused-vars
          router.afterEach((routeTo, routeFrom) => {
            document.body.classList.remove("sidebar-enable");
          });
          document.body.classList.remove("vertical-collpsed");
        }
        this.isMenuCondensed = !this.isMenuCondensed;
      },
      toggleRightSidebar() {
        document.body.classList.toggle("right-bar-enabled");
      },
      hideRightSidebar() {
        document.body.classList.remove("right-bar-enabled");
      },
    },
    mounted() {
      if (this.loader) {
        document.getElementById("preloader").style.display = "block";
        document.getElementById("status").style.display = "block";

        setTimeout(function () {
          document.getElementById("preloader").style.display = "none";
          document.getElementById("status").style.display = "none";
        }, 2500);
      } else {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }
    },
  };
</script>

<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper" >
      <NavBar  />
      <SideBar v-if="$can('read', 'Property')"  :is-condensed="isMenuCondensed" type="light" width="fluid" />
      <!-- ============================================================== -->
      <!-- Start Page Content here -->
      <!-- ============================================================== -->

      <div class="main-content">
        <TopNav />
        <div class="page-content">
          <!-- Start Content-->
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <Footer />
      </div>
    </div>
    <VirtualTourView v-if="this.virtualTourLink" :viewSource="this.virtualTourLink" />
    <SupportEmail />
  </div>

</template>
